'use strict';

import angular from 'angular';
import LangController from './lang.controller';

export default angular.module('updateServerApp.firmwares.lang', [])
  .controller('FirmwaresLangController', LangController)
  .name;



// WEBPACK FOOTER //
// ./client/app/firmwares/lang/index.js